$(function () {
  // Initialize Vue after DOM is fully loaded
  const getInitPrice2 = () => {
    let basePrice = $('#js-nav-quick').data('price') || 0
    if (basePrice) {
      basePrice = typeof basePrice == 'string' ? parseFloat(basePrice.replace(/,/g, '')) : parseFloat(basePrice);
    }
    return basePrice
  }
  const skypdp = {
    sku: $('#js-product-quikbuy').data('sku') || '',
  };
  function newQuickBuy() {
    if (document.getElementById('js-product-quikbuy')) {
      new Vue({
        el: '#js-product-quikbuy',
        delimiters: ['${', '}'],
        data() {
          return {
            sku: skypdp.sku,
            selectionAttrs: [],
            availableAttrs: [],
            selectedValues: [],
            productInfo: {
              model: '',
              brand: '',
              image: '',
              price: 0,
              salesUnit: '',
              moq: 1,
              mpq: 1,
              sku: '',
              variantId: '',
              discountJson: []
            },
            quantity: 1,
            quantityReplace: 1,
            minQuantity: 1,
            loading: false
          }
        },
        computed: {
          shouldHideAttributeSelector() {
            return (
              this.selectionAttrs.find((item) => item.attrName == 'match') ||
              this.selectionAttrs.length == 0
            );
          },
          formattedPrice() {
            return QuantityUtils.calculateJietiPrice(this.productInfo, this.quantity, 'price1')
            //  return this.productInfo?.price ? skyFormatPriceDisplay(parseFloat(this.productInfo.price).toFixed(2)) : '';
          },
          totalPrice() {
            return QuantityUtils.calculateTotalPrice(this.productInfo, this.quantity)
          },
          isDisabled() {
            const requiredCount = this.selectionAttrs.length;
            const validSelections = this.selectedValues.slice(0, requiredCount).filter(val => val && val != '');
            if (validSelections.length < requiredCount) return true;
            return !this.availableAttrs.some(item =>
              item.attrs?.slice(0, requiredCount).every((attr, i) => attr == this.selectedValues[i])
            );
          },
          showViewDetails() {
            return this.productInfo?.skuCode && this.productInfo.skuCode != skypdp.sku;
          }
        },
        async created() {
          await this.init();
        },
        methods: {
          async init() {
            if (skypdp.sku) {
              await this.getSelectionAttrs();
            }
          },
          async getSelectionAttrs() {
            try {
              const res = await kkAjax.get(`/spu/selection-attrs/other?sku=${skypdp.sku}`);
              if (res.code == 200 && res.data) {
                this.selectionAttrs = (res.data.selectionAttrs || []).filter(item => item.attrName != 'match');
                this.availableAttrs = res.data.availableAttrs || [];
                const matchedProduct = this.availableAttrs.find(item => item.skuCode == skypdp.sku);
                this.selectedValues = new Array(this.selectionAttrs.length).fill('');
                this.getProductData(matchedProduct)
                this.calculateCurrentSkuAttrs();
              }
            } catch (err) {
              console.error('Failed to fetch selection attributes:', err);
            }
          },
          getProductData(info) {
            this.productInfo = {
              ...info,
              moq: parseInt(info.moq) || 1,
              mpq: parseInt(info.mpq) || 1,
              sku: info.skuCode || '',
              image: info.image || '',
              brand: info.brand || '',
              model: info.model || '',
              price: info.price || 0,
              salesUnit: info.salesUnit || '',
              variantId: info.variantId || '',
              discountJson: info.quantityDiscount || []
            };
            this.quantity = this.productInfo.moq;
            this.quantityReplace = this.productInfo.moq;
            this.minQuantity = this.productInfo.moq;
          },
          calculateCurrentSkuAttrs() {
            if (!this.productInfo?.sku || !this.availableAttrs?.length) return;
            const currentSkuAttrs = this.availableAttrs.find(item => item.skuCode == this.productInfo.sku);
            if (currentSkuAttrs?.attrs) {
              this.selectedValues = [...currentSkuAttrs.attrs.slice(0, this.selectionAttrs.length)];
            }
          },
          getSelectOptions(attr, attrIndex) {
            if (!attr?.values) return [];
            if (attrIndex == 0) {
              return attr.values;
            }
            return this.getAvailableValuesForIndex(attrIndex);
          },
          getAvailableValuesForIndex(targetIndex) {
            if (!this.availableAttrs?.length) return [];
            const currentSelections = this.selectedValues.slice();
            const availableValues = new Set();

            this.availableAttrs.forEach(item => {
              if (!item.attrs || item.attrs.length <= targetIndex) return;
              let isCompatible = true;
              for (let i = 0; i < targetIndex; i++) {
                if (currentSelections[i] && currentSelections[i] != '' && item.attrs[i] != currentSelections[i]) {
                  isCompatible = false;
                  break;
                }
              }
              if (isCompatible) {
                availableValues.add(item.attrs[targetIndex]);
              }
            });

            return Array.from(availableValues);
          },
          onSelectChange(value, index) {
            this.selectedValues[index] = value;
            // 检查当前组合是否仍然有效
            const isCurrentCombinationValid = this.availableAttrs.some(item => {
              if (!item.attrs || item.attrs.length < this.selectionAttrs.length) return false;
              // 检查所有已选择的属性是否匹配
              for (let i = 0; i < this.selectionAttrs.length; i++) {
                if (this.selectedValues[i] && this.selectedValues[i] !== '' && item.attrs[i] !== this.selectedValues[i]) {
                  return false;
                }
              }
              return true;
            });
            // 只有当前组合无效时才清空后续选择
            if (!isCurrentCombinationValid) {
              for (let i = index + 1; i < this.selectionAttrs.length; i++) {
                this.selectedValues[i] = '';
              }
            }
            this.checkAndRedirectToSku();
          },
          clearIncompatibleSelections(changedIndex) {
            const requiredCount = this.selectionAttrs.length;
            for (let i = 0; i < requiredCount; i++) {
              if (i == changedIndex || !this.selectedValues[i]) continue;
              const isCompatible = this.availableAttrs.some(item => {
                if (!item.attrs || item.attrs.length < requiredCount) return false;

                for (let j = 0; j < requiredCount; j++) {
                  if (this.selectedValues[j] && item.attrs[j] != this.selectedValues[j]) {
                    return false;
                  }
                }
                return true;
              });
              if (!isCompatible) {
                this.selectedValues[i] = '';
              }
            }
          },
          checkAndRedirectToSku() {
            const requiredCount = this.selectionAttrs.length;
            const validSelections = this.selectedValues.slice(0, requiredCount).filter(val => val && val != '');

            if (validSelections.length < requiredCount) return;

            const matchedSku = this.availableAttrs.find(item => {
              if (!item.attrs) return false;
              return item.attrs.slice(0, requiredCount).every((attr, i) => attr == this.selectedValues[i]);
            });

            if (matchedSku?.skuCode) this.getProductData(matchedSku);
          },
          increaseQuantity() {
            const moq = this.productInfo?.moq || 1;
            const mpq = this.productInfo?.mpq || 1;
            const maxQuantity = 1000000;
            let newValue = this.quantity + mpq;

            if (newValue > maxQuantity) {
              newValue = maxQuantity;
            }
            this.quantity = newValue;
            this.quantityReplace = newValue;
          },
          decreaseQuantity() {
            const moq = this.productInfo?.moq || 1;
            const mpq = this.productInfo?.mpq || 1;
            let newValue = this.quantity - mpq;

            if (newValue < moq) {
              newValue = moq;
            }

            this.quantity = newValue;
            this.quantityReplace = newValue;
          },
          onQuantityInputChange(event) {
            const moq = this.productInfo?.moq || 1;
            const mpq = this.productInfo?.mpq || 1;
            const maxQuantity = 1000000;
            let inputValue = parseInt(event.target.value);
            if (isNaN(inputValue) || inputValue === 0 || inputValue < moq) {
              this.quantity = this.minQuantity
              this.quantityReplace = this.minQuantity
              return false
            }
            if (inputValue < moq) {
              inputValue = moq;
            }
            const remainder = (inputValue - moq) % mpq;
            if (remainder != 0) {
              inputValue = Math.ceil((inputValue - moq) / mpq) * mpq + moq;
            }
            if (inputValue > maxQuantity) {
              inputValue = maxQuantity;
            }
            this.quantity = inputValue;
            this.quantityReplace = inputValue;
          },
          viewProductDetails() {
            if (this.productInfo?.sku) {
              window.location.href = `/products/${this.productInfo.sku}`;
            }
          },
          async addToCart() {
            // ZIP Code restriction check
            var zipcodeRangesAttr = document.querySelector('.js-zkh-addtocart[data-zipcode-ranges]');
            if (zipcodeRangesAttr && window.checkZipcodeRestriction(zipcodeRangesAttr.getAttribute('data-zipcode-ranges'))) {
              return;
            }
            this.loading = true;
            try {
              await cartFormModule.addToCart({
                variantId: this.productInfo.variantId,
                quantity: this.quantity
              });
            } catch (error) {
              console.error('Add to cart failed:', error);
            } finally {
              this.loading = false;
            }
          }
        }
      });
    }
  }
  // big b2b
  if (!window.themeVariables.userCompany.showCatalogPrice) {
    newQuickBuy();
  }
})